import Detail from "../../components/Common/DetailModel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
import { Nav, NavItem, NavLink } from "reactstrap";
const DetailReservation = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [loading, setLoading] = useState(true);
  const [modeleData, setModeleData] = useState([]);
  const [impressionsData, setImpressionData] = useState([]);
  const [activeTab, setActiveTab] = useState("details");
  const token = localStorage.getItem("auth_token_" + api);
  const [wait, setWait] = useState(1000);
  let { id } = useParams();
  const navigate = useNavigate();
  const handleAction = async (action) => {
    console.log(
      action.controller +
        "/" +
        action.action +
        "/" +
        action.params.sauvegardes_attestation_id
    );
    // navigate(-1)

    // Mettez ici votre logique pour gérer l'action
  };
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails modèles Réservation
          </NavLink>
        </NavItem>

        {modeleData?.hm_accessibles?.map((key, index) =>
          key === "hm_impressions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "impressions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("impressions")}
              >
                {!loading ? (
                  impressionsData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_reservations/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const modeleData = await response.json();
      setModeleData(modeleData);

      {
        modeleData?.hm_accessibles?.map(async (key, index) =>
          key === "hm_impressions" ? await getImpressions() : null
        );
      }
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };

  const getImpressions = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/publipostages_reservations/${id}/hm_impressions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setImpressionData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      await getData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  if (localStorage.getItem("key") === "true") {
    toast.success("Mise à jour réussie");
    setTimeout(() => {
      localStorage.setItem("key", "false");
    }, 100);
  }
  /// Liste balise
  const [listeData, setListeData] = useState("");

  const getListe = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages/list_tags?type_filtre_id=8`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setListeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Detail
      getListe={getListe}
      listeData={listeData.message}
      Titre={"Modèles Réservation"}
      loading={loading}
      setLoading={setLoading}
      modeleData={modeleData}
      impressionsData={impressionsData}
      activeTab={activeTab}
      handleAction={handleAction}
      toggleModal={toggleModal}
      handleTabClick={handleTabClick}
      fetchData={fetchData}
      id={id}
      CustomNavTabs={CustomNavTabs}
      api={"publipostages_reservations"}
      wait={wait}
    />
  );
};

export default DetailReservation;
